













import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';

import { getSpeakers } from '@/api/index';

const MultiselectSpeaker = defineComponent({
  props: {
    value: {},
    rules: { type: String },
    label: { type: String, default: 'ผู้พูด' },
  },
  setup(props: any) {
    const speaker = ref();
    const speakersId: number[] = reactive([]);
    const speakersName: string[] = reactive([]);

    watch(() => props.value, (newVal) => {
      if (newVal) {
        if (newVal.length > 0) {
          speaker.value = newVal;
        }
      }
    });

    onMounted(async () => {
      const { data, ...pagination } = await getSpeakers(1, 200, (null as any));
      data.forEach((elm: any) => {
        speakersId.push(elm.id);
        speakersName.push(elm.name);
      });
    });

    return {
      speaker,
      speakersId,
      speakersName,
    };
  },
});

export default MultiselectSpeaker;
